import { brand } from "@/config/brand";
import { cn } from "@/lib/utils";

const SIZE_HEIGHT_PX: Record<LogoSize, number> = {
  sm: 16,
  md: 24,
  lg: 40,
};

type LogoSize = "sm" | "md" | "lg";
type LogoVariant = "full" | "mark";

interface LogoProps {
  /** Rendered height; width is derived from the logo's fixed aspect ratio. */
  size?: LogoSize;
  /** Reserved for a future icon-only mark; only "full" (wordmark) exists today. */
  variant?: LogoVariant;
  className?: string;
}

/**
 * The brand wordmark. This is the only component that may reference the
 * logo asset path — everywhere else should render `<Logo />` instead of
 * pointing at `brand.logo.primary` directly.
 */
export function Logo({ size = "md", variant = "full", className }: LogoProps) {
  const height = SIZE_HEIGHT_PX[size];
  const width = Math.round(height * brand.logo.aspectRatio);

  return (
    <span className={cn("inline-flex items-center gap-1.5", className)}>
      <img
        src={brand.logo.primary}
        alt={brand.name}
        title={variant === "mark" ? undefined : brand.name}
        width={width}
        height={height}
        className="shrink-0"
      />
    </span>
  );
}
